export default __webpack_public_path__ + "static/media/bandMember-Tony.a3d456c8.jpg";